import { Extension } from "@tiptap/core";
import Placeholder from "@tiptap/extension-placeholder";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

import { unescapeHTML, escapeHTML } from "@/view/utils/htmlEscape";
import { editorWrapper } from "./WritePromptTextInput.style";

const InsertBreakOnOnter = Extension.create({
  name: "BreakOnOnter",
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.insertContent("<br>"),
    };
  },
});

interface WritePromptTextInputProps {
  handleChange: (text: string) => undefined;
  text: string;
}

const WritePromptTextInput = ({
  handleChange,
  text: rawText,
}: WritePromptTextInputProps) => {
  const text = escapeHTML(rawText);
  const editor = useEditor({
    content: text,
    extensions: [
      StarterKit,
      InsertBreakOnOnter,
      Placeholder.configure({
        considerAnyAsEmpty: true,
        placeholder: "Start typing...",
      }),
    ],
    onUpdate: () => {
      if (editor) {
        const text = unescapeHTML(editor.getText());
        handleChange(text);
      }
    },
  });

  if (!editor) return null;

  return (
    <div css={editorWrapper}>
      <EditorContent editor={editor} />
    </div>
  );
};

export default WritePromptTextInput;
